import { Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import LinkConstants from "../../../constants/LinkConstants.ts";
import { useApiLimitStatus } from "../../../hooks/useApiLimitStatus.tsx";
import { useAppStore } from "../../../hooks/useStores.tsx";
import iframeStore from "../../../pages/IframeNew/iframe-store.tsx";
import { isCampaignEditor } from "../../../utils/index.ts";
import ConfirmationPopup from "../../common/ConfirmationPopup/ConfirmationPopup.tsx";
import styles from "./ApiLimitReachedPopup..module.scss";

const ApiLimitReachedPopup = () => {
	const { t } = useTranslation("translation", { keyPrefix: "passedFreeLimitsPopup" });
	const { authStore, pricingStore, uiStore } = useAppStore();
	const { trialEnded, isUserCreatedBeforeGrowthDate, orgUsage, freeLimit } = useApiLimitStatus();

	const isPostGrowthUsageLimitBeforeQuotaExhausted =
		!isUserCreatedBeforeGrowthDate && authStore.orgPassedFreeLimit && orgUsage < freeLimit;

	const showUpgradePrimaryAction =
		trialEnded || (!isUserCreatedBeforeGrowthDate && !isPostGrowthUsageLimitBeforeQuotaExhausted);

	return (
		<ConfirmationPopup
			paperClassName={styles.passedFreeLimitsPopup}
			onClose={() => {
				if (!iframeStore.isIframe() && !isCampaignEditor) {
					uiStore.hideDialog("ApiLimitReachedPopup");
				}
			}}
			title={t("title")}
			hideCloseIcon={iframeStore.isIframe() || isCampaignEditor}
			hideCancel={true}
			description={
				isUserCreatedBeforeGrowthDate ? (
					trialEnded ? (
						<Typography className={styles.description} component="div">
							<span dangerouslySetInnerHTML={{ __html: t("descriptionLegacy14DayTrial") }} />
							{iframeStore.isIframe() ? <span>{t("description2Iframe")}</span> : null}
						</Typography>
					) : (
						<Typography className={styles.description}>
							{t("descriptionUsageLimitLegacy14DayTrial")}
							<span>{t("description2UsageLimitLegacy14DayTrial")}</span>
							{iframeStore.isIframe() ? <span>{t("description2Iframe")}</span> : null}
						</Typography>
					)
				) : isPostGrowthUsageLimitBeforeQuotaExhausted ? (
					<Typography className={styles.description}>
						{t("descriptionUsageLimit")}
						<span>{t("description2UsageLimit")}</span>
						{iframeStore.isIframe() ? <span>{t("description2Iframe")}</span> : null}
					</Typography>
				) : (
					<Typography className={styles.description} component="div">
						<span dangerouslySetInnerHTML={{ __html: t("description") }} />
						{iframeStore.isIframe() ? <span>{t("description2Iframe")}</span> : null}
					</Typography>
				)
			}
			open={
				(!iframeStore.isIframe() || (!iframeStore.isPreview() && iframeStore.isInitialized)) &&
				authStore.orgPassedFreeLimit &&
				uiStore.ApiLimitReachedPopup &&
				!pricingStore.isPricingFlowOpen
			}
			onClick={() => {
				if (showUpgradePrimaryAction) {
					if (iframeStore.isIframe()) {
						window.open(LinkConstants.CONTACT_US_FORM_LINK, "_blank");
					} else {
						pricingStore.openPricingFlow();
					}
				} else {
					// @ts-expect-error: Usage limit reached before trial / quota exhausted: open chatbot/support widget
					if (typeof window !== "undefined" && window.HubSpotConversations?.widget) {
						// @ts-expect-error: open chat
						window.HubSpotConversations.widget.open();
					}
				}
			}}
			confirmButtonText={
				showUpgradePrimaryAction
					? t(iframeStore.isIframe() ? "buttonTextIframe" : "buttonText")
					: t("buttonTextUsageLimit")
			}
		/>
	);
};

export default observer(ApiLimitReachedPopup);
